import React, { useState } from 'react';
import { GAMES } from './games';
import { pageOf as paging } from '../lib/paging';
import { randomOther } from '../lib/random';

export const PAGE_SIZE = 1;

// kept here so the games test can import it from the component
export const pageOf = (items, page, size = PAGE_SIZE) => paging(items, page, size);

function WebGames() {
  const [page, setPage] = useState(0);
  const view = pageOf(GAMES, page);
  const game = view.items[0];

  return (
    <div className="fm-pick">
      <div className="fm-stepper" role="group" aria-label="Game">
        <button type="button" className="ms-btn ms-btn-small" onClick={() => setPage(view.at - 1)} disabled={view.at === 0} aria-label="Previous game">◀</button>
        <span className="fm-stepper-name" aria-live="polite">game <small>{view.at + 1}/{view.pages}</small></span>
        <button type="button" className="ms-btn ms-btn-small" onClick={() => setPage(view.at + 1)} disabled={view.at === view.pages - 1} aria-label="Next game">▶</button>
      </div>
      <h3 className="fm-pick-title"><span className="fm-clamp">{game.title}</span></h3>
      <p className="fm-pick-note"><span className="fm-clamp">{game.blurb}</span></p>
      <div className="fm-pick-actions">
        <button type="button" className="ms-btn fm-pick-main" onClick={() => setPage(randomOther(view.at, view.pages))}>🎲 shuffle</button>
        <a className="ms-btn fm-pick-main" href={game.url} target="_blank" rel="noopener noreferrer">Play ↗</a>
      </div>
    </div>
  );
}

export default WebGames;
